






















































import { Component, Vue } from "vue-property-decorator";
import TermsAndConditionsLink from "@app/shared/components/termsAndConditions/termsAndConditionsLink.vue";
import * as ApplicationStore from "@src/store/applicationStore";

@Component({
    components: {
        TermsAndConditionsLink
    }
})
export default class ContactDetailsAndPrivacy extends Vue {
    private get contactDetails(): Array<ProxyModel.ContactDetailViewModel> {
        return [
            {name: "Next Health", tel: "(08) 9201 3300", email: "info@nexthealth.com.au"},
            {name: "Medilaw NSW", tel: "1300 633 452", email: "adminNSW@medilaw.com.au"}
        ];
    }

    get isOfba(): boolean {
        return ApplicationStore.isOfba(this.$store);
    }
}
